import { request } from "graphql-request";
import { graphql } from "gql/gql";

import { BACKEND_DOMAIN } from "utils/constants";
import {
    buildRequestHeaders,
    buildBuildingModelRequestVariables,
} from "utils/helpers";

const queryFn = (accessToken: string, buildingModelUid: string) =>
    request({
        url: `${BACKEND_DOMAIN}/graphql`,
        document: query,
        variables: buildBuildingModelRequestVariables(buildingModelUid),
        requestHeaders: buildRequestHeaders(accessToken),
    }).then((data) => {
        if (data.energyAggregation.error)
            throw new Error(data.energyAggregation.error);
        return data.energyAggregation as EnergyAggregationByFuelType;
    });

const query = graphql(`
    query energyAggregation($buildingModelUid: Uuid!) {
        energyAggregation(buildingModelUid: $buildingModelUid) {
            error
            electricity {
                averageUtilityRate
                endDate
                lastUpdated
                startDate
                totalEnergyConsumption
                totalEntries
                totalUtilityCost
            }
            naturalGas {
                averageUtilityRate
                endDate
                lastUpdated
                startDate
                totalEnergyConsumption
                totalEntries
                totalUtilityCost
            }
        }
    }
`);

export default queryFn;
